import React from 'react';
import './Keranjang.css';
import Payout from './Payout';
import { ToastContainer, toast, Slide } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CurrencyFormat from 'react-currency-format';



class Keranjang extends React.Component {
    constructor(props) {
        super(props);
        this.state ={
            products: [],
            finalProducts:[],
            totalPrice:''
        }
        this.addProduct = this.addProduct.bind(this)
        this.minProduct = this.minProduct.bind(this)
        this.removeProduct = this.removeProduct.bind(this)
    }
    componentDidMount() {
        let totalPrice = 0;
        JSON.parse(localStorage.getItem('cartProducts')).map(  e => 
            {
            let price = parseInt(e.price.match(/\d/g).join(""))
            let qty = parseInt(e.availability)
            totalPrice += (price*qty)
            return void 0
            }
        )
        this.setState ({
            products: JSON.parse(localStorage.getItem('cartProducts')),
            totalPrice: totalPrice
        })

        window.scrollTo(0, 0)
    }

    addProduct(e,product) {
        product.availability = parseInt(product.availability) + 1;
        let fixProducts = this.state.products.map(e => (e.id === product.id ? {...e, product} : e))
        this.setState({
            products: fixProducts
          });
        localStorage.setItem('cartProducts',JSON.stringify(fixProducts))
        this.totalPrice(fixProducts)
        
    }

    minProduct(e,product) {
        if(product.availability > 1) {
            product.availability = parseInt(product.availability) - 1;
            let fixProducts = this.state.products.map(e => (e.id === product.id ? {...e, product} : e))
            this.setState({
                products: fixProducts
            });
            localStorage.setItem('cartProducts',JSON.stringify(fixProducts))
            this.totalPrice(fixProducts)
        } else {
            toast.warn(`Tekan tanda [X] untuk menghapus product`)
        }
    }

    removeProduct (e,product) {
        let products = this.state.products.filter((e) => e.id !== product.id)
        this.setState ({
            products: products
        })
        let count = parseInt(localStorage.getItem('count'), 10) - 1;
        localStorage.setItem('count',count)
        localStorage.setItem('cartProducts',JSON.stringify(products))
        this.totalPrice(products)
        toast.warn(`${product.title} berhasil di hapus`)
    }

    
    totalPrice (products) {
        let totalPrice = 0;
        products.map(  e => 
            {
            let price = parseInt(e.price.match(/\d/g).join(""))
            let qty = parseInt(e.availability)
            totalPrice += (price*qty)
            return void 0
            }
        )
        this.setState ({
            totalPrice: totalPrice
        })
    }



    render () {
      return (
        <div className="keranjang jumbotron jumbotron-fluid">
            <h1>Keranjang</h1>
            <div className="container">
                    {
                    this.state.products.map(
                        (products) => 
                        <div className="row" key={products.id}>
                            <div className="col-lg-3 col-md-3 col-4 mx-auto my-auto" >
                                <img className="img-fluid image shadow rounded"  src={"https://api-ls.faisalhakim.com/public/api/image/"+products.filename} alt=""/>
                            </div>
                            <div className="col-lg-3 col-md-3 col-4 mx-auto my-auto information" >
                                <h5 className="text-left bg-screen" title={products.title}>{products.title}</h5>
                                <h6 className="text-left sm-screen" title={products.title}>{products.title.length > 15 ? products.title.substring(0, 15)+'...': products.title}</h6>
                                <p className="card-text price text-left">
                                <span className="font-weight-light">{products.description}</span>
                                    <br/>
                                    <CurrencyFormat value={parseInt(products.price.match(/\d/g).join(""))} displayType={'text'} thousandSeparator={true} prefix={'Rp.'} />
                                    <br/>
                                    {products.priceChanges === "1" ? <small className="font-weight-light font-italic">*Harga Estimasi</small> : ""}
                                </p>
                            </div>
                            <div className="col-lg-1 col-md-1 col-1 mx-auto my-auto" >
                                <p className="card-text price text-center">
                                Qty &nbsp;
                                {products.availability}
                                </p>
                            </div>
                            <div className="col-lg-2 col-md-2 col-2 mx-auto my-auto" >
                                <button type="button" className="btn btn-sm btn-primary" title="Tambahkan" onClick={(e) => this.addProduct(e,products)}><i className="fa fa-plus" aria-hidden="true"></i></button>
                                <button type="button" className="btn btn-sm btn-info" title="Kurangi" onClick={(e) => this.minProduct(e,products)}><i className="fa fa-minus" aria-hidden="true"></i></button>
                                <button type="button" className="btn btn-sm btn-danger" title="Hapus" onClick={(e) => this.removeProduct(e,products)}><i className="fa fa-times" aria-hidden="true"></i></button>
                            </div>
                        </div>
                    )}
                    {this.state.products.length === 0 ? <p>Tidak ada product di keranjang</p> : ""}
            </div>
            <Payout totalPrice={this.state.totalPrice}/>
            <ToastContainer
              position="top-center"
              transition={Slide}
              autoClose={3000}
              hideProgressBar
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover={false}
            />
        </div>
      );
    }
  }


export default Keranjang;
